<template>
  <vz-collapse-info public-style class="run-schedule-collapse color-low mt-30">
    <template #header>
      <div class="flex">
        {{ title }}
        <vz-icon
          name="information-outline"
          size="18"
          class="ml-5"
        />
      </div>
    </template>
    <div v-html="info" class="mb-20"/>
  </vz-collapse-info>
</template>

<script setup lang="ts">
import VzCollapseInfo from '~/components/ui-kit/vz-collapse-info.vue'

const props = defineProps({
  mode: {
    type: String,
    default: 'schedule'
  }
})

const collapseItems = [
  {
    title: 'Расписание рейсов',
    value: 'schedule',
    info: 'Чтобы узнать расписание рейсов междугородней или международной перевозки - выберите город отправления и получения в списке. В верхней части сформированной таблицы будет указано время отправления рейса от терминала, а под ним - количество дней в пути. В нижней части таблицы указано время прибытия рейса на терминал в городе получения.'
  },
  {
    title: 'Расчёт сроков доставки',
    value: 'calculation',
    info: 'Данная форма поможет выбрать оптимальное время для отправки груза, чтобы получить его в необходимый срок. <ul class="public-list mb-10"><li>Укажите желаемую дату получения груза в поле "Дата доставки".</li><li>Выберите город отправления и получения из списка.</li></ul>В первой колонке таблицы будет указано когда груз необходимо сдать на терминал или водителю на адресе.<br>Во второй - когда груз прибудет в город получения. В последней - когда его можно получить на терминале или по адресу.'
  }
]

const title = computed((): String => {
  return collapseItems.find(v => v.value === props.mode)?.title || ''
})

const info = computed((): String => {
  return collapseItems.find(v => v.value === props.mode)?.info || ''
})
</script>